import {
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  Table,
  TableHead,
  IconButton,
} from "@mui/material";
import { fDateTime } from "src/utils/formatTime";
import Iconify from "../iconify";

const getPermissionName = (relatedType) => {
  switch (relatedType) {
    case 0:
      return "Superadmin";
    case 1:
      return "Admin";
    case 2:
      return "Editor";
    case 3:
      return "Viewer";
    case 4:
      return "Client";
    default:
      return "?";
  }
};

export default function AdminsTable(props) {
  const { admins, onMenuOpen } = props;

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Admin ID</TableCell>
            <TableCell>Username</TableCell>
            <TableCell>Permission Level</TableCell>
            <TableCell>Updated At</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {admins?.map((row, index) => (
            <TableRow
              key={index}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
              }}
            >
              <TableCell component="th" scope="row">
                {row.adminId}
              </TableCell>
              <TableCell component="th" scope="row">
                <a href={`/dashboard/profile?user_id=${row.userId}`}>
                  {row.username}
                </a>
              </TableCell>
              <TableCell component="th" scope="row">
                {getPermissionName(row.permissionLevel, row.reference)}
              </TableCell>
              <TableCell component="th" scope="row">
                {fDateTime(row.updatedAt)}
              </TableCell>
              <TableCell align="right">
                <IconButton
                  size="large"
                  color="inherit"
                  onClick={onMenuOpen}
                  id={row.adminId}
                >
                  <Iconify icon={"eva:more-vertical-fill"} />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
